import { Dot } from "./Dot";
import { Ellipsis } from "./Ellipsis";
import { Block, Circle, Description } from "./Loader";

export const Loader = {
  Block,
  Description,
  Dot,
  Ellipsis,
  Circle,
};
